import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useTreatmentsWithConfig } from "@splitsoftware/splitio-react";
import { memo } from "react";
import featureFlags from "../../constants/feature-flags.json";
export var FEATURE_FLAGS = featureFlags;
/**
 * FeatureToggle component accepts a single child component or a components tuple.
 * Components in a tuple should have "data-treatment" property with (on|off) value.
 *
 * If a single component is provided - it will be rendered based on the treatment ("on" or "off") from Split.io.
 *
 * If a tuple of components is provided - only the one matching the treatment will be rendered.
 *
 * If no configuration is found for a given toggle, the component will not be rendered.
 */ export var FeatureToggle = /*#__PURE__*/ memo(function FeatureToggle(param) {
    var children = param.children, flagName = param.flagName;
    var isMock = import.meta.env.MODE !== "production" || import.meta.env.VITE_MOCK;
    var _useTreatmentsWithConfig = useTreatmentsWithConfig({
        names: [
            flagName
        ]
    }), isReady = _useTreatmentsWithConfig.isReady, treatments = _useTreatmentsWithConfig.treatments;
    if (isMock) {
        if (Array.isArray(children) && children.length > 1) {
            var _children_find;
            return (_children_find = children.find(function(child) {
                return (child === null || child === void 0 ? void 0 : child.props["data-treatment"]) === "on";
            })) !== null && _children_find !== void 0 ? _children_find : null;
        }
        return /*#__PURE__*/ _jsx(_Fragment, {
            children: children
        });
    }
    if (!isReady) {
        return null;
    }
    var treatment = treatments[flagName];
    if (!treatment) {
        return null;
    }
    if (Array.isArray(children) && children.length > 1) {
        var _children_find1;
        return (_children_find1 = children.find(function(child) {
            return (child === null || child === void 0 ? void 0 : child.props["data-treatment"]) === treatment.treatment;
        })) !== null && _children_find1 !== void 0 ? _children_find1 : null;
    }
    return treatment.treatment === "on" ? /*#__PURE__*/ _jsx(_Fragment, {
        children: children
    }) : null;
});

//# sourceMappingURL=FeatureToggle.js.map